export const PAGE_TITLE = 'Plataforma de Gestión Minera de la Provincia de Buenos Aires';

/** El title del layout es un espacio. ProLayout igual concatena "Pantalla - {title}". */
export const documentTitleFromPage = (pageName?: string) => {
  const screenTitle = pageName?.trim();
  return screenTitle || PAGE_TITLE;
};
